module.exports = __webpack_public_path__ + "img/hdlog.8e8cfdfa.png";